import React from 'react';
import { get, post, put, del, patch } from '../../Utility/Http';
import { roleCreatePost, roleCreatePatch, role_list_get, roleStatusUpdateApi, roleDeleteApi, getHotelBranchListGet } from '../Model/RoleModel';

import * as Store from '../../../store'
let version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";

export const roleCreate = async (data, id, type) => {
    if (type == 'post') {
        const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}roles`, data);
        return roleCreatePost(response);
    } else {
        const response_1 = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}roles/${id}`, data);
        return roleCreatePatch(response_1);
    }
};

export const roleList = async (filters = {}) => {
  // Format filters according to the API structure
  // let queryParams = {};
  // const filtersObj = {
  //   branch_id: filters.branch_id
  // };

  //   queryParams.filters = JSON.stringify(filtersObj);
  

  const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}roles`, filters);
  return role_list_get(response);
};

export const roleStatusUpdate = async (id, data) => {
    const response = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}roles/${id}`, data);
    return roleStatusUpdateApi(response);
};

export const roleDelete = async (data) => {
    const response = await del(`${process.env.EXTENDED_URL_WITHOUT_VERSION}roles`, data);
    return roleDeleteApi(response);
};

export const getHotelBranchList = async (data) => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org_branch`, data);
    return getHotelBranchListGet(response);
};

export const getStoreList = async (data, userType = "admin", hotelId, storeSlack = "") => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    let response = "";
    // Use new store-hierarchy endpoint if storeSlack is provided
    if (storeSlack) {
        response = await get(`${process.env.EXTENDED_URL}store-hierarchy/${storeSlack}/child-stores`, data);
    } else {
        version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
        response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org_branch`, data);
        return getHotelBranchListGet(response);
    }

    return getHotelBranchListGet(response);
};
